<template><section><template>
<h3>Switch</h3>
<div class="bs-docs-section">
<div class="bs-example">
<p></p><h3><n3-switch v-model="value"></n3-switch></h3><p></p>
<p></p><h3><n3-switch ontext="ON" offtext="OFF" @change="toggle" v-model="value"></n3-switch></h3><p></p>
<p></p><h3><n3-switch ontext="NO" offtext="OFF" @change="toggle" :disabled="true"></n3-switch></h3><p></p>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-switch</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-switch</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-switch</span> <span class="hljs-attr">ontext</span>=<span class="hljs-string">"ON"</span> <span class="hljs-attr">offtext</span>=<span class="hljs-string">"OFF"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"toggle"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-switch</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-switch</span> <span class="hljs-attr">ontext</span>=<span class="hljs-string">"ON"</span> <span class="hljs-attr">offtext</span>=<span class="hljs-string">"OFF"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"toggle"</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-switch</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>disabled</td>
<td><code v-pre="">boolean</code></td>
<td><code v-pre="">false</code></td>
<td>disabled</td>
</tr>
<tr>
<td>ontext</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">ON</code></td>
<td>text of NO</td>
</tr>
<tr>
<td>offtext</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">OFF</code></td>
<td>text of OFF</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>change</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value: false
    }
  },
  methods: {
    toggle (state) {
      console.log(state)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3SwitchDocs.md?942f337a